<template>
   <div class="crud-wrapper">
      <crud-toolbar
              :modal-mode="modalMode"
              :new-state="newState"
              :title="modalTitle"
              @onCommand="toolbarCommand"
      ></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">
         <v-layout row wrap>
            <a-text-field label="Nome" disabled sm6 v-model="formData.personName"></a-text-field>
            <a-date-field label="Solicitado em" disabled dateFormat="DD/MM/YYYY" v-model="formData.createdAt" sm6></a-date-field>
            <a-text-field label="Código do Usuário" :append-outer-icon="'content_copy'" :append-outer-icon-cb="copyReferral" sm6 v-model="formData.referralCode"></a-text-field>
            <a-text-field label="Link" v-model="formData.url" sm12></a-text-field>
            <a-select-field label="Situação" obj="requestStatus" v-model="formData.requestStatusId" sm12></a-select-field>
         </v-layout>
      </crud-form>
   </div>
</template>
<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
    import 'viewerjs/dist/viewer.css';

    export default CrudFormClass.extend({
        name: 'RequestForm',

        data () {
            return {
                title: 'Solicitação',
                formName: 'RequestForm',

                cloudinaryImages: [],

                formData: {
                    id: null,
                    personName: null,
                    createdAt: null,
                    referralCode: null,
                    url: null,
                    requestStatusId: null
                }
            };
        },

        methods: {
            copyReferral() {
                window.Clipboard.copy(this.formData.referralCode);

                this.$notifyUser({
                    message: 'Texto Copiado!'
                });
            },
        }
    });
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/RequestForm.vue